/* Akoviya · Funnel page script: photo slider, pack picker, ships-by dates, marquee loop, sticky bar, scroll-to-order. */
(function () {
  if (window.AkoviyaFunnel) return;

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || '₹{{amount}}';
    function group(n, decimals, thousands, dec) {
      var fixed = (n / 100).toFixed(decimals).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (fixed[1] ? dec + fixed[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- ships-by dates ---------- */
  function initShipDates(root) {
    root.querySelectorAll('[data-fn-ship-date]').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + (parseInt(el.getAttribute('data-fn-ship-date'), 10) || 0));
      if (el.getAttribute('data-fn-skip-sunday') === 'true' && d.getDay() === 0) d.setDate(d.getDate() + 1);
      var lang = document.documentElement.lang || 'en-IN';
      try { el.textContent = d.toLocaleDateString(lang.indexOf('en') === 0 ? 'en-IN' : lang, { day: 'numeric', month: 'long', year: 'numeric' }); }
      catch (e) { el.textContent = d.toDateString(); }
    });
  }

  /* ---------- photo slider ---------- */
  function initGallery(gal) {
    if (gal.dataset.fnReady) return;
    gal.dataset.fnReady = '1';
    var track = gal.querySelector('[data-fn-gal-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = gal.querySelectorAll('[data-fn-gal-go]');
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i, smooth) {
      var n = slides.length;
      if (!n) return;
      i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) {
        if (k === i) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else t.removeAttribute('aria-current');
      });
    }
    gal.addEventListener('click', function (e) {
      var step = e.target.closest('[data-fn-gal-step]');
      if (step) { go(current() + parseInt(step.getAttribute('data-fn-gal-step'), 10)); return; }
      var t = e.target.closest('[data-fn-gal-go]');
      if (t) go(parseInt(t.getAttribute('data-fn-gal-go'), 10));
    });
    var timer;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(function () { mark(current()); }, 80); }, { passive: true });
    gal.fnGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-fn-media-id')) === String(mediaId)) { go(i); return; }
      }
    };
  }

  /* ---------- pack picker ---------- */
  function initHero(hero) {
    if (hero.dataset.fnReady) return;
    hero.dataset.fnReady = '1';
    var dataEl = hero.querySelector('[data-fn-product]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    hero.addEventListener('change', function (e) {
      var input = e.target.closest('[data-fn-var]');
      if (!input) return;
      var v = data.variants.filter(function (x) { return String(x.id) === input.value; })[0];
      if (v) applyVariant(hero, data, v);
    });
  }

  function applyVariant(hero, data, v) {
    document.querySelectorAll('[data-fn-variant-input]').forEach(function (inp) {
      inp.value = v.id;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var save = v.compare > v.price ? v.compare - v.price : 0;
    var pct = save ? Math.floor(save * 100 / v.compare) : 0;
    var units = v.units || data.units || 1;
    var values = {
      price: formatMoney(v.price, data.format), compare: formatMoney(v.compare, data.format), save: formatMoney(save, data.format),
      pct: String(pct), unit: formatMoney(v.price / units, data.format), units: String(units)
    };
    document.querySelectorAll('.fn [data-fn-m]').forEach(function (el) {
      var key = el.getAttribute('data-fn-m');
      if (key in values) el.textContent = values[key];
    });
    document.querySelectorAll('.fn [data-fn-if-compare]').forEach(function (el) { el.hidden = !save; });
    document.querySelectorAll('.fn [data-fn-atc]').forEach(function (btn) {
      if (v.available) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
      var label = btn.querySelector('[data-fn-atc-label]');
      if (label) label.textContent = v.available ? (btn.getAttribute('data-fn-label') || '').replace('[save_percent]', pct) : (btn.getAttribute('data-fn-soldout') || 'Sold out');
    });
    if (v.media) document.querySelectorAll('.fn [data-fn-gal]').forEach(function (g) { if (g.fnGoToMedia) g.fnGoToMedia(v.media); });
    if (window.history && history.replaceState && !window.Shopify?.designMode) {
      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- marquee ---------- */
  function initMarquee(mq) {
    var track = mq.querySelector('[data-fn-mq-track]');
    if (!track || track.dataset.fnReady) return;
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;
    track.dataset.fnReady = '1';
    function cloneSet() {
      originals.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('video').forEach(function (vid) { vid.muted = true; vid.play && vid.play().catch(function () {}); });
        track.appendChild(c);
      });
    }
    var setWidth = track.scrollWidth;
    var copies = 1;
    while (setWidth * copies < window.innerWidth && copies < 12) { cloneSet(); copies++; }
    for (var k = 0; k < copies; k++) cloneSet();
  }

  /* ---------- sticky bar ---------- */
  function initSticky(bar) {
    if (bar.dataset.fnReady) return;
    bar.dataset.fnReady = '1';
    var after = parseInt(bar.getAttribute('data-fn-after'), 10) || 0;
    var buyVisible = false;
    var buy = document.getElementById('fn-buy');
    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { buyVisible = entries[0].isIntersecting; update(); }).observe(buy);
    }
    function update() { bar.classList.toggle('is-on', window.scrollY > after && !buyVisible); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- scroll-to-order buttons ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-fn-scroll]');
    if (!a) return;
    var target = document.getElementById('fn-buy') || document.querySelector('product-form');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var btn = target.querySelector('button[type="submit"]');
    if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, 600);
  });

  function init(root) {
    root = root || document;
    initShipDates(root);
    root.querySelectorAll('[data-fn-gal]').forEach(initGallery);
    root.querySelectorAll('[data-fn-hero]').forEach(initHero);
    root.querySelectorAll('[data-fn-marquee]').forEach(initMarquee);
    root.querySelectorAll('[data-fn-sticky]').forEach(initSticky);
  }

  window.AkoviyaFunnel = { init: init, formatMoney: formatMoney };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
